/*
 * @Description: 备案合同待办历史接口
 * @Date: 2026-09-18
 */
import service from '@/utils/request'

// 备案合同待办历史列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/violationContractJob/historyPage',
    data: params
  })

// 企业名称（下拉）
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })
